module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="fmcy-order-complete-inner">\n  <div class="fmcy-order-complete-thankyou-headline">THANK YOU</div>\n  <div class="fmcy-order-complete-headline">FARM '+
((__t=( locationName ))==null?'':__t)+
' has received your order</div>\n  ';
 if (deliveryMethod == 'pickup') { 
__p+='\n  <div class="fmcy-order-complete-order-sub-headline"><p>Next, you will receive a notification once your order is packaged and ready for pick up. Orders placed during open hours will be packaged within 1 hour, and orders placed after hours will be packaged when the store is next open.</p>\n  <p>Thank you for using Click and Collect.</p></div>\n  <div class="fmcy-order-complete-step-indicator pickup"></div>\n  ';
 } else { 
__p+='\n  <div class="fmcy-order-complete-order-sub-headline"><p>Thank you for choosing Original Farm! Your order for delivery to '+
((__t=(deliveryAddress))==null?'':__t)+
' has been received. The Original Farm will prepare your order and let you know when it is ready to be sent out. Estimated delivery time is '+
((__t=(deliveryWindowMinutes))==null?'':__t)+
' minutes from now. If you have any questions or concerns, please contact us.</p>\n  <p>Thank you for using Original Farm Delivery.</p></div>\n  <div class="fmcy-order-complete-step-indicator delivery"></div>\n  ';
 } 
__p+='\n</div>\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/cart/order-complete/order-complete.html
 ** module id = 641
 ** module chunks = 1 9 12 141
 **/